/**
 * How It Works section component
 * Explains the 3-step process of using Wurlo
 */
function HowItWorksSection() {
  // Steps data array for easy maintenance
  const steps = [
    {
      icon: (
        <svg width="26" height="26" viewBox="0 0 24 24" aria-hidden="true" stroke="white" strokeWidth="2.5" fill="none">
          <path d="M12 3v3M12 18v3M3 12h3M18 12h3M6 6l2.5 2.5M15.5 15.5L18 18M6 18l2.5-2.5M15.5 8.5L18 6" strokeLinecap="round"/>
        </svg>
      ),
      color: 'from-indigo-500 to-indigo-600',
      title: '1. Give students a diagnostic test',
      description: 'Students complete a test that is generated for their needs',
    },
    {
      icon: (
        <svg width="26" height="26" viewBox="0 0 24 24" aria-hidden="true" stroke="white" strokeWidth="2.5" fill="none">
          <path d="M4 7h16M4 12h10M4 17h16" strokeLinecap="round"/>
        </svg>
      ),
      color: 'from-cyan-500 to-cyan-600',
      title: '2. Review clear diagnostic insights',
      description: "See exactly what each student knows, where they're struggling, and which topics need attention most.",
    },
    {
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" aria-hidden="true" stroke="white" strokeWidth="2.2" fill="none">
          <path d="M18 15v3a2 2 0 0 1-2 2H7" strokeLinecap="round"/>
          <path d="M6 9V6a2 2 0 0 1 2-2h9" strokeLinecap="round"/>
          <path d="M6 18.5l-2-2 2-2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M18 5.5l2 2-2 2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M8 14v3M12 12v5M16 10v7" strokeLinecap="round"/>
        </svg>
      ),
      color: 'from-amber-500 to-amber-600',
      title: '3. Get repeatable insights',
      description: "Repeat this process multiple times as they progress so you don't miss anything important!",
    },
  ];

  return (
    <section id="how-it-works" aria-labelledby="how-title" className="bg-white border-t border-b border-slate-200">
      <div className="mx-auto max-w-7xl mobile-full-width px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <div className="text-center max-w-2xl mx-auto mb-8">
          <h2 id="how-title" className="text-3xl sm:text-4xl font-bold text-slate-900 mb-3">
            How Wurlo Works for You
          </h2>
          <p className="text-lg text-slate-700">
            Deep Student Diagnosis and test generation — giving you more time to teach.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 lg:gap-8">
          {steps.map((step, index) => (
            <div key={index} className="card-hover rounded-2xl border-2 border-slate-200 bg-white p-6 shadow-modern">
              <div className={`w-14 h-14 rounded-xl bg-gradient-to-br ${step.color} flex items-center justify-center shadow-lg`}>
                {step.icon}
              </div>
              <h3 className="mt-5 text-xl font-bold text-slate-900">{step.title}</h3>
              <p className="mt-3 text-base text-slate-600 leading-relaxed">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default HowItWorksSection;
